import * as React from "react";

import {faceIconColor} from "@khan/auth-shared";

export const AppleIcon = ({
    disabled = false,
    ariaHidden,
}: {
    disabled?: boolean;
    ariaHidden?: boolean;
}): React.ReactElement<React.ComponentProps<"svg">> => {
    const fadeFn = faceIconColor(disabled);

    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden={ariaHidden}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18.89 17.03C18.62 17.66 18.29 18.24 17.92 18.77C17.41 19.49 16.99 20.00 16.67 20.27C16.17 20.73 15.63 20.97 15.06 20.98C14.65 20.98 14.15 20.86 13.58 20.63C13.00 20.39 12.46 20.27 11.98 20.27C11.47 20.27 10.92 20.39 10.33 20.63C9.75 20.86 9.28 20.99 8.91 21.00C8.37 21.02 7.82 20.78 7.27 20.27C6.92 19.97 6.49 19.45 5.96 18.71C5.40 17.93 4.94 17.02 4.58 15.98C4.19 14.85 4 13.76 4 12.71C4 11.50 4.26 10.46 4.79 9.59C5.20 8.89 5.74 8.34 6.43 7.93C7.11 7.53 7.85 7.32 8.65 7.31C9.09 7.31 9.66 7.44 10.37 7.71C11.08 7.97 11.54 8.11 11.74 8.11C11.88 8.11 12.39 7.95 13.25 7.64C14.06 7.35 14.74 7.23 15.30 7.27C16.82 7.40 17.96 7.99 18.72 9.07C17.36 9.89 16.69 11.04 16.71 12.51C16.72 13.66 17.14 14.62 17.96 15.38C18.33 15.73 18.74 16.00 19.21 16.19C19.11 16.48 19.00 16.76 18.89 17.03ZM15.40 3.36C15.40 4.26 15.07 5.10 14.42 5.88C13.62 6.80 12.66 7.34 11.62 7.25C11.61 7.15 11.60 7.03 11.60 6.91C11.60 6.05 11.98 5.12 12.65 4.37C12.98 3.98 13.41 3.67 13.93 3.41C14.44 3.16 14.93 3.02 15.39 3C15.40 3.12 15.40 3.24 15.40 3.36V3.36Z"
                fill={fadeFn("#000000")}
            />
        </svg>
    );
};
